<div class="w-full flex flex-col gap-2" *transloco="let t">
    <app-mb-horizontal-menu class=" sticky top-0 z-30 " />
    <!-- Top section -->
    <div
      class="bg-gradient-to-r from-mbaza-primary to-mbaza-secondary flex flex-row justify-between items-center px-5 h-15/100 py-12 rounded-sm relative overflow-hidden before:absolute before:inset-0 before:bg-[radial-gradient(circle,white_2px,transparent_2px)] before:bg-[length:20px_20px] before:opacity-15 before:pointer-events-none"
    >
      <span class="relative z-10 text-xl font-extrabold text-white px-2">{{ t('welcome') }} {{ user?.firstName }},</span>
      <!--
        DISMISS COMPLAINT BUTTON - DISABLED
        Reason: The "Dismiss Complaint" (reject) action was removed from the New Case modal
        because the product no longer requires agents to reject/dismiss complaints from this view.
        To re-enable, add the following two attributes back to the <app-mb-modal> below
        (right after the (CancelActionHandler) line):
            [alternativeActionButtonText]="selectedComplaint?.acknowledgedComment===null ? t('rejectComplaint'):null "
            (alternativeActionHandler)="showCloseComplaintModal()"
        Note: Angular's template parser does not allow HTML comments between attributes
        inside an opening tag, so the disabled attributes are documented here instead of
        being commented inline.
      -->
      <app-mb-modal
        #modal
        [(isVisible)]="isModalVisible"
        [title]="t('newCase')"
        [okText]="t('createCase')"
        [width]="'60%'"
        [desktopWidth]="'80%'"
        [icon]="ASSET_CONSTANTS.I_stars"
        [okLoading]="isCaseSubmitting"
        (OkActionHandler)="onModalOkAction()"
        (CancelActionHandler)="onModalCancelAction()"
      >
          @if (isLoading) {
          <div class="flex items-center justify-center h-full">
            <div class="text-center">
              <div
                class="animate-spin rounded-full h-12 w-12 border-b-2 border-mbaza-primary mx-auto mb-4"
              ></div>
              <p class="text-mbaza-gray">{{ t('loading') }}</p>
            </div>
          </div>
          } @else {
          <app-new-case-form
            #newCaseForm
            [complaintData]="selectedComplaint"
            [complaintId]="selectedComplaintId"
            (caseCreated)="onCaseCreated($event)"
          />
          }
      </app-mb-modal>
      <app-mb-button
        label="{{ t('newCase') }}"
        (click)="modal.showModal()"
        class="relative z-10"
        type="accent"
        *appMbPermissionCheck="'CREATE_CASE'"
      />
    </div>

    <!-- Urgent cases and complaints section -->
    <div class="flex flex-col lg:flex-row gap-2">
      <div class="w-full lg:w-5/12 flex flex-col space-y-4 bg-white rounded-sm p-6 relative ">
        <app-mb-banner
          [title]="
            (isAcknowledgedFilter === true
              ? t('dismissedComplaints')
              : t('nonOrientedComplaints')) + ' (' + totalItems + ')'
          "
          type="warning"
          [icon]="ASSET_CONSTANTS.I_stars_orange"
        >
          <div class="flex items-center gap-2 -mt-2">
            <img
              [src]="ASSET_CONSTANTS.I_filter_vertical"
              alt="filter"
              class="w-5 h-5 cursor-pointer grayscale"
              tabindex="0"
              (click)="showFilterModal()"
              (keydown.enter)="showFilterModal()"
              (keydown.space)="showFilterModal()"
            />
          </div>
        </app-mb-banner>
        <!-- Filter and refresh section -->
        <app-mb-search
          [(searchValue)]="searchTerm"
          (searchSubmit)="onSearchValueChange($event)"
          (clearSearch)="onClearSearch()"
          prefixLabel="{{ t('filter') }}"
          placeholder="{{ t('enterNamesKeyword') }}"
          class="w-full rounded-full"
          height="2.5rem"
          (searchValueChange)="onSearchValueChange($event)"
        />

        <!-- Complaints table -->
        @if (isLoadingComplaints) {
          <app-mb-skeleton *ngIf="isLoadingComplaints" [columns]="3"  [rows]="6"/>
        } @else if (filteredComplaints.length === 0) {
          <div class="flex items-center justify-center ">
            <app-mb-empty-list />
          </div>
        } @else {
        <nz-table
          [nzData]="filteredComplaints"
          [nzFrontPagination]="false"
          class="rounded relative w-full overflow-x-auto [scrollbar-width:thin] [scrollbar-color:#8E8E8E]"
        >
          <tbody>
          <tr
            class="w-full justify-between text-sm cursor-pointer hover:bg-gray-50"
              *ngFor="let complaint of filteredComplaints; let i = index"
              tabindex="0"
              (click)="onComplaintClick(complaint.id)"
              (keydown.enter)="onComplaintClick(complaint.id)"
              [class.opacity-50]="isLoading"
            >
              <td class="whitespace-nowrap px-4 py-3">{{ ((currentPage - 1) * pageSize) + i + 1 }}
              </td>
              <td class="font-semibold whitespace-nowrap px-4 py-3 truncate text-ellipsis" style="min-width: 4rem;max-width: 6rem;">
                {{ complaint.createdFor }}
              </td>
              <td class=" text-mbaza-gray whitespace-nowrap px-4 py-3" style="min-width: 1rem;">
                {{ complaint.createdAt | date : "dd MMM yyyy" }}
              </td>
              <td class="text-mbaza-gray whitespace-nowrap px-4 py-3 font-semibold" style="min-width: 4rem;">
                {{ complaint.createdAt | daysAgo }}
              </td>
              <td class="text-mbaza-gray whitespace-nowrap px-4 py-3 truncate text-ellipsis" style="min-width: 4rem; max-width: 6rem;">
                {{ complaint.title }}
              </td>
              <td class="whitespace-nowrap px-4 py-3">
                <img
                  [src]="ASSET_CONSTANTS.I_arrow_right"
                  alt="arrow right"
                  class="w-4 h-4 grayscale-100 absolute right-2 top-1/2 transform -translate-y-1/2 pointer-events-none"
                />
              </td>
            </tr>
          </tbody>
        </nz-table>
        <nz-pagination
          [nzPageIndex]="currentPage"
          [nzTotal]="totalItems"
          [nzPageSize]="pageSize"
          *ngIf="totalItems > pageSize"
          (nzPageIndexChange)="onPageChange($event)"
          style="text-align: right; padding-top: 10px"
        ></nz-pagination>
        }
      </div>
      <div class="w-full lg:w-7/12 relative bg-white rounded-sm p-6 overflow-y-auto flex flex-col gap-4">
        <app-mb-banner
          title="{{ t('urgentCases') }}"
          type="danger"
          [icon]="ASSET_CONSTANTS.I_info"
        >
        <div class="flex items-center gap-2 -mt-2">
          <img
            [src]="ASSET_CONSTANTS.I_filter_vertical"
            alt="filter"
            class="w-5 h-5 cursor-pointer grayscale"
            tabindex="0"
            (click)="showUrgentFilterModal()"
            (keydown.enter)="showUrgentFilterModal()"
            (keydown.space)="showUrgentFilterModal()"
          />
        </div>
        </app-mb-banner>
        @if (isLoadingUrgentCases) {
          <app-mb-skeleton *ngIf="isLoadingUrgentCases" [columns]="3"  [rows]="6"/>
        }
        @else if (listOfUrgentCases.length === 0) {
        <div class="flex items-center justify-center h-full">
          <app-mb-empty-list />
        </div>
        } @else {
        <nz-table
          nzShowSizeChanger
          [nzData]="listOfUrgentCases"
          [nzFrontPagination]="false"
          class="rounded relative w-full overflow-x-auto [scrollbar-width:thin] [scrollbar-color:#8E8E8E]"
        >
          <tbody>
          <tr
            class="w-full justify-between text-sm cursor-pointer hover:bg-gray-50"
                 *ngFor="let case of listOfUrgentCases; let i = index"
                 (click)="onUrgentCaseClick(case.id)"
                 (keydown.enter)="onUrgentCaseClick(case.id)"
                 tabindex="0">
              <td class="px-4 py-3 flex" style="min-width: 1rem;">
                {{ ((urgentCurrentPage - 1) * urgentPageSize) + i + 1 }}</td>
              <td class="font-semibold truncate text-ellipsis px-4 py-3" style="min-width: 4rem; max-width: 8rem;" >
                {{ case.createdFor }}
              </td>
              <td class="text-mbaza-gray  whitespace-nowrap  px-4 py-3" style="min-width: 4rem; max-width: 6rem;">{{ case.createdAt | date : "dd MMM yyyy" }}</td>
              <td class="text-mbaza-gray whitespace-nowrap px-4 py-3 font-semibold" style="min-width: 4rem;">
                {{ case.createdAt | daysAgo }}
              </td>
              <td class="font-semibold px-4 py-3 truncate whitespace-nowrap  text-ellipsis" style="min-width: 10rem; max-width: 16rem;">
                {{ case.categoryNames.join(', ') }}
              </td>
              <td class="text-mbaza-gray whitespace-nowrap  px-4 py-3 " style="min-width: 4rem;">
                {{case.title }}
              <td class="text-mbaza-accent font-semibold underline whitespace-nowrap  px-4 py-3" style="min-width: 4rem;">
              #{{ case.applicationNumber  }}
              </td>
              <td class="whitespace-nowrap  px-4 py-3" style="min-width: 4rem;">
                <img
                  [src]="ASSET_CONSTANTS.I_danger"
                  alt="urgent"
                  class="w-5 h-5"
                />
              </td>
              <td class="px-4 py-3" style="min-width: 4rem; max-width: 6rem;">
                <img
                  [src]="ASSET_CONSTANTS.I_arrow_right"
                  alt="arrow right"
                  class="w-5 h-5 grayscale"
                />
              </td>
            </tr>
          </tbody>
        </nz-table>
        <nz-pagination
          [nzPageIndex]="urgentCurrentPage"
          [nzTotal]="urgentTotalItems"
          [nzPageSize]="urgentPageSize"
          *ngIf="urgentTotalItems > urgentPageSize"
          (nzPageIndexChange)="onUrgentPageChange($event)"
          style="text-align: right; padding-top: 10px"
        ></nz-pagination>
        }
      </div>
    </div>

    <!-- Complaints Filters Modal -->
    <app-mb-modal
      [isVisible]="isFilterModalVisible"
      [title]="t('filterComplaints')"
      [icon]="ASSET_CONSTANTS.I_grey_stars"
      [width]="'50%'"
      [desktopWidth]="'50%'"
      [footerDisabled]="true"
      (CancelActionHandler)="handleFilterModalCancel()"
      (isVisibleChange)="isFilterModalVisible = $event"
    >
      <div class="p-4 flex flex-col gap-4">

        <div class="flex flex-col gap-2">
          <span class="font-bold text-sm">{{ t('byLocation') }}</span>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-1">
            <app-mb-select
              *ngIf="shouldShowDistrictLocationFilter"
              [(ngModel)]="complaintFilterForm.district"
              [options]="districtOptions"
              [prefixLabel]="t('district')"
              [hasShortText]="true"
              class="w-full"
              placeholder="{{ t('allDistricts') }}"
              (handleChange)="handleFilterChange('district', $event)"
            />
            <app-mb-select
              *ngIf="shouldShowSectorLocationFilter"
              [(ngModel)]="complaintFilterForm.sector"
              [options]="sectorOptions"
              [prefixLabel]="t('sector')"
              [hasShortText]="true"
              class="w-full"
              placeholder="{{ t('allSectors') }}"
              (handleChange)="handleFilterChange('sector', $event)"
            />
            <app-mb-select
              *ngIf="shouldShowCellLocationFilter"
              [(ngModel)]="complaintFilterForm.cell"
              [options]="cellOptions"
              [prefixLabel]="t('cell')"
              [hasShortText]="true"
              class="w-full"
              placeholder="{{ t('allCells') }}"
              (handleChange)="handleFilterChange('cell', $event)"
            />
            <app-mb-select
              [(ngModel)]="complaintFilterForm.village"
              [options]="villageOptions"
              [prefixLabel]="t('village')"
              [hasShortText]="true"
              class="w-full"
              placeholder="{{ t('allVillages') }}"
              (handleChange)="handleFilterChange('village', $event)"
            />
          </div>
        </div>

        <div class="flex flex-col gap-2">
          <span class="font-bold text-sm">{{ t('byPeriod') }}</span>
          <app-mb-select
            [(ngModel)]="complaintFilterForm.scope"
            [options]="scopeOptions"
            [prefixLabel]="t('period')"
            [hasShortText]="true"
            class="w-full"
            placeholder="{{ t('allPeriods') }}"
          />
        </div>

        <div class="flex flex-col gap-2">
          <span class="font-bold text-sm">{{ t('byStatus') }}</span>
          <app-mb-select
            [(ngModel)]="complaintFilterForm.isAcknowledged"
            [options]="acknowledgmentOptions"
            [prefixLabel]="t('status')"
            [hasShortText]="true"
            class="w-full"
            placeholder="{{ t('allStatus') }}"
          />
        </div>



        <div class="flex items-center justify-between gap-1 mt-2">
          <app-mb-button
            label="{{ t('clearFilters') }}"
            type="ghost"
            (click)="handleFilterClear()"
            (keydown.enter)="handleFilterClear()"
            (keydown.space)="handleFilterClear()"
          />
          <app-mb-button
            label="{{ t('confirmClose') }}"
            type="secondary"
            (click)="handleFilterApply()"
            (keydown.enter)="handleFilterApply()"
            (keydown.space)="handleFilterApply()"
          />
        </div>
      </div>
    </app-mb-modal>

    <!-- Urgent Cases Location Filters Modal -->
    <app-mb-modal
      [isVisible]="isUrgentFilterModalVisible"
      [title]="t('filter')"
      [icon]="ASSET_CONSTANTS.I_grey_stars"
      [width]="'50%'"
      [desktopWidth]="'50%'"
      [footerDisabled]="true"
      (CancelActionHandler)="handleUrgentFilterModalCancel()"
      (isVisibleChange)="isUrgentFilterModalVisible = $event"
    >
      <div class="p-4 flex flex-col gap-4">
        <div class="flex flex-col gap-2">
          <span class="font-bold text-sm">{{ t('byLocation') }}</span>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-1">
            <app-mb-select
              *ngIf="shouldShowDistrictLocationFilter"
              [(ngModel)]="urgentFilterForm.district"
              [options]="urgentDistrictOptions"
              [prefixLabel]="t('district')"
              [hasShortText]="true"
              class="w-full"
              placeholder="{{ t('allDistricts') }}"
              (handleChange)="handleUrgentFilterChange('district', $event)"
            />
            <app-mb-select
              *ngIf="shouldShowSectorLocationFilter"
              [(ngModel)]="urgentFilterForm.sector"
              [options]="urgentSectorOptions"
              [prefixLabel]="t('sector')"
              [hasShortText]="true"
              class="w-full"
              placeholder="{{ t('allSectors') }}"
              (handleChange)="handleUrgentFilterChange('sector', $event)"
            />
            <app-mb-select
              *ngIf="shouldShowCellLocationFilter"
              [(ngModel)]="urgentFilterForm.cell"
              [options]="urgentCellOptions"
              [prefixLabel]="t('cell')"
              [hasShortText]="true"
              class="w-full"
              placeholder="{{ t('allCells') }}"
              (handleChange)="handleUrgentFilterChange('cell', $event)"
            />
            <app-mb-select
              [(ngModel)]="urgentFilterForm.village"
              [options]="urgentVillageOptions"
              [prefixLabel]="t('village')"
              [hasShortText]="true"
              class="w-full"
              placeholder="{{ t('allVillages') }}"
              (handleChange)="handleUrgentFilterChange('village', $event)"
            />
          </div>
        </div>

        <div class="flex items-center justify-between gap-1 mt-2">
          <app-mb-button
            label="{{ t('clearFilters') }}"
            type="ghost"
            (click)="handleUrgentFilterClear()"
            (keydown.enter)="handleUrgentFilterClear()"
            (keydown.space)="handleUrgentFilterClear()"
          />
          <app-mb-button
            label="{{ t('confirmClose') }}"
            type="secondary"
            (click)="handleUrgentFilterApply()"
            (keydown.enter)="handleUrgentFilterApply()"
            (keydown.space)="handleUrgentFilterApply()"
          />
        </div>
      </div>
    </app-mb-modal>

    <!--
      ============================================================
      CLOSE / REJECT COMPLAINT MODAL - DISABLED
      ============================================================
      Reason: This modal was triggered by the "Dismiss Complaint" button
      on the New Case modal (alternativeActionHandler -> showCloseComplaintModal()).
      Since that trigger was removed, this modal can no longer be opened
      and is kept here only as commented reference in case the
      reject/close-complaint workflow is reintroduced later.

      To re-enable:
        1. Uncomment the [alternativeActionButtonText] and
           (alternativeActionHandler) attributes on the New Case modal above.
        2. Uncomment this entire <app-mb-modal> block.
        3. Ensure the following are uncommented in the .ts file:
           - isCloseComplaintModalVisible
           - isClosingComplaint
           - closeComplaintForm + FormBuilder injection
           - closeCommentLength getter
           - showCloseComplaintModal()
           - handleCloseComplaintSubmit()
           - onCloseComplaintModalCancel()
    -->
    <!--
    <app-mb-modal
    [(isVisible)]="isCloseComplaintModalVisible"
    [title]="t('rejectComplaint')"
    [okText]="t('confirmClose')"
    [desktopWidth]="'40%'"
    [mobileWidth]="'90%'"
    [okDisabled]="closeComplaintForm.invalid || isClosingComplaint"
    (OkActionHandler)="handleCloseComplaintSubmit()"
    (CancelActionHandler)="onCloseComplaintModalCancel()"
    >
    <form
      [formGroup]="closeComplaintForm"
      class="p-4 flex flex-col gap-3"
      (ngSubmit)="handleCloseComplaintSubmit()"
    >
      <div class="flex flex-col gap-2">
        <span class="font-semibold text-base">{{ t('addAComment') }} <span class="font-normal text-mbaza-gray "> ( 30 - 3000 {{t('characters')}})</span></span>
        <textarea
          class="w-full border border-gray-200 rounded-sm p-3 min-h-[120px] focus:outline-none focus:ring-1 focus:ring-mbaza-primary"
          formControlName="comment"
          placeholder="{{ t('explainWhyThisComplaintIsBeingClosed') }}"
        ></textarea>
        @if (
          closeComplaintForm.get('comment')?.invalid
        ) {
          <span class="text-mbaza-gray text-sm">
           {{ t('charactersCount') }}:{{ closeCommentLength }}
          </span>
        }
        <p class="text-sm text-mbaza-text-dark">
          {{ t('thisCommentWillBeRecordedWithTheComplaintClosure') }}
        </p>
      </div>
    </form>
    </app-mb-modal>
    -->
</div>
